
import { getLangName as t } from '../utils/index'

export const Locaiotn = {
    settings : t('case'),
    contactUs:t('contact'),
    productCenter:t('product'),
    dashDetail:t('ProductDetail'),
    settingsDetail:t('CaseDetails'),
    aboutCompany:t("aboutCompany")
}
